import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-user-list-header',
  templateUrl: 'job-possible-user-list-header.component.html',
  styleUrls: ['job-possible-user-list-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobPossibleUserListHeaderComponent {
  @Output() searchChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() checkboxChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() multiDay?: boolean;
  @Input() isLoading: boolean = false;
  @Input() suggestInsteadDirectAccept: boolean = false;
  @Input() jobInPast: boolean = false;

  public onCheckboxClick(event: MatCheckboxChange): void {
    this.checkboxChange.emit(event.checked);
  }
}
